import { Image, View } from "@aws-amplify/ui-react";
import { useMediaQuery } from "@mui/material";
import { images } from "constants/index";
import { motion } from "framer-motion";

export const TheSolutions = () => {
  const matches = useMediaQuery("(min-width:1000px)");
  return (
    <View className="relative flex flex-col px-5 pt-10">
      <motion.div
        initial={{
          opacity: 0.3,
          scale: 0.8,
        }}
        whileInView={{
          opacity: 1,
          scale: 1,
        }}
        transition={{ duration: 2 }}
      >
        <View className="relative flex w-full justify-end">
          <div className="font-extrabold text-[66px] font-lolita-one">
            THE SOLUTIONS
          </div>
        </View>
      </motion.div>
      <View className={`relative flex flex-row  justify-center`}>
        <Image
          display={matches ? "" : "none"}
          alt=""
          position="relative"
          objectFit="cover"
          width={300}
          height={600}
          src={images.flower2}
        />
        <div className="relative flex flex-col p-10  w-[100%] bg-[rgba(203,213,225,.3)] shadow-2xl rounded-2xl font-lolita-one">
          {/* <motion.div
            initial={{
              opacity: 0.3,
              scale: 0.2,
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
            }}
            transition={{
              duration: 3,
              type: "spring",
            }}
          > */}
          <div className="font-extrabold text-[40px] underline">
            FEEDING THOSE IN NEED
          </div>
          <div className=" text-white font-medium text-[22px]">
            PROVIDING FRESH AND FREE PRODUCE THROUGH OUR FOOD PANTRIES .
          </div>

          <div className="font-extrabold text-[40px] underline">
            HOSTING ACTIVITIES
          </div>
          <div className=" text-white font-medium text-[22px]">
            KEEPING OUR YOUTH HAPPY & HEALTHY THROUGH SKATEBOARDING
          </div>

          <div className="font-extrabold text-[40px] underline">
            RESTORING MENTAL HEALTH
          </div>
          <div className=" text-white font-medium text-[22px]">
            HOSTING WELLNESS EVENTS FOR HEALING AND PROVIDING THE YOUTH WITH
            MENTAL HEALTH MENTORS.
          </div>

          <div className="font-extrabold text-[40px] underline">
            CLEANING OUR HOODS
          </div>
          <div className=" text-white font-medium text-[22px]">
            MEETING WITH DISTRICT LEADERS FOR COMMUNITY IMPROVEMENTS AND GAINING
            ACCESS TO LANDS TO TURN INTO COMMUNITY FARMS.
          </div>

          <div className="font-extrabold text-[40px] underline">
            REPAIRING OUR COMMUNITY
          </div>
          <div className=" text-white font-medium text-[22px]">
            CREATING A SAFE SPACE TO HOST CULTURAL AND MUSIC EVENTS FOR THE
            COMMUNITIES ENJOYMENT.
          </div>

          {/* </motion.div> */}
        </div>
        <Image
          alt=""
          display={matches ? "" : "none"}
          objectFit="cover"
          alignSelf="flex-end"
          marginLeft={30}
          width={100}
          height={250}
          src={images.flower}
        />
      </View>
    </View>
  );
};
